import Button from './Button';

/**
 * CtaBanner
 *
 * Props:
 *   headline: string
 *   sub: string
 *   primaryLabel: string
 *   primaryHref: string — external link; used only if onPrimaryClick / primaryTo are NOT provided
 *   primaryTo: string — internal route; renders <Link> (takes precedence over primaryHref)
 *   onPrimaryClick: function — when provided, renders a <button> instead of a link
 *   outlineLabel: string
 *   outlineHref: string — external/tel link; renders <a>
 *   outlineTo: string — internal route; renders <Link> (takes precedence over outlineHref)
 */
function CtaBanner({
  headline = 'Ready to Grow Your Amazon Business?',
  sub = 'Join hundreds of sellers who trust Nation Wholesale LLC for premium wholesale products, full compliance documentation, and unbeatable pricing.',
  primaryLabel = 'Apply for Wholesale',
  primaryHref = '/#contact',
  primaryTo,
  onPrimaryClick,
  outlineLabel,
  outlineHref,
  outlineTo,
}) {
  return (
    <div className="cta-banner" id="contact">
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <h2>{headline}</h2>
        <p>{sub}</p>
        <div className="cta-banner-actions">
          {onPrimaryClick ? (
            <Button variant="primary" onClick={onPrimaryClick}>
              {primaryLabel}
            </Button>
          ) : primaryTo ? (
            <Button variant="primary" to={primaryTo}>
              {primaryLabel}
            </Button>
          ) : (
            <Button
              variant="primary"
              href={primaryHref}
              {...(/^https?:\/\//i.test(primaryHref)
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
            >
              {primaryLabel}
            </Button>
          )}
          {outlineLabel && (outlineTo || outlineHref) && (
            <Button
              variant="outline"
              {...(outlineTo ? { to: outlineTo } : { href: outlineHref })}
              style={{ color: 'white' }}
            >
              {outlineLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CtaBanner;
